var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3779 4.28875L11.2113 0.12207C11.1331 0.0439453 11.0273 0 10.9166 0H2.16664C1.24789 0 0.5 0.747461 0.5 1.66668V18.3334C0.5 19.2525 1.24789 20 2.16668 20H13.8334C14.7521 20 15.5 19.2525 15.5 18.3333V4.58332C15.5 4.47266 15.4561 4.36688 15.3779 4.28875ZM11.3333 1.42254L14.0775 4.16668H12.1666C11.7068 4.16668 11.3333 3.79273 11.3333 3.33336V1.42254ZM14.6667 18.3333C14.6667 18.7927 14.2931 19.1666 13.8334 19.1666H2.16668C1.70687 19.1666 1.33336 18.7927 1.33336 18.3333V1.66668C1.33336 1.2073 1.70691 0.833359 2.16668 0.833359H10.5V3.33336C10.5 4.25254 11.2479 5 12.1667 5H14.6667V18.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5833 11.6666H3.41668C3.18637 11.6666 3 11.853 3 12.0833C3 12.3136 3.18637 12.5 3.41668 12.5H12.5834C12.8137 12.5 13 12.3136 13 12.0833C13 11.853 12.8136 11.6666 12.5833 11.6666Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5833 9.16675H3.41668C3.18637 9.16675 3 9.35312 3 9.58343C3 9.81375 3.18637 10.0001 3.41668 10.0001H12.5834C12.8137 10.0001 13 9.81375 13 9.58343C13 9.35312 12.8136 9.16675 12.5833 9.16675Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5833 14.1666H3.41668C3.18637 14.1666 3 14.353 3 14.5833C3 14.8136 3.18637 15 3.41668 15H12.5834C12.8137 15 13 14.8136 13 14.5833C13 14.353 12.8136 14.1666 12.5833 14.1666Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41668 16.6666H3.41668C3.18637 16.6666 3 16.853 3 17.0833C3 17.3136 3.18637 17.5 3.41668 17.5H8.41668C8.64699 17.5 8.83336 17.3136 8.83336 17.0833C8.83332 16.853 8.64699 16.6666 8.41668 16.6666Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.08984C3 7.31655 3.31948 7.5 3.7143 7.5H12.2857C12.6805 7.5 13 7.31655 13 7.08984C13 6.86314 12.6805 6.67969 12.2857 6.67969H3.7143C3.31948 6.67973 3 6.86318 3 7.08984Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.59637C3 4.82668 3.18637 5.01305 3.41668 5.01305H8.41669C8.64701 5.01305 8.83337 4.82668 8.83337 4.59637C8.83337 4.36605 8.64701 4.17969 8.41669 4.17969H3.41668C3.18637 4.17973 3 4.36609 3 4.59637Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.481e7914.svg";
export { ForwardRef as ReactComponent };